import { Action } from 'redux';
import { Epic } from 'redux-observable';

import {
    changeFilterTextRegionsEditor,
    ChangeFilterTextRegionsEditor,
    START_CHANGE_FILTER_TEXT_REGIONS_EDITOR,
    StartChangeFilterTextRegionsEditor
} from '../../actions/regionsEditor';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

const DEBOUNCE_TIME = 1000;

const startChangeFilterTextRegionsEditorEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$
        .ofType(START_CHANGE_FILTER_TEXT_REGIONS_EDITOR)
        .debounceTime(DEBOUNCE_TIME)
        .map(
            (action: StartChangeFilterTextRegionsEditor): ChangeFilterTextRegionsEditor => {
                return changeFilterTextRegionsEditor(action.id, action.value, action.tree);
            }
        );
};

export { startChangeFilterTextRegionsEditorEpic };
